<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:09:19
 * @LastEditTime: 2019-08-18 17:38:28
 * @LastEditors: Please set LastEditors
 -->
<template>
    <el-dialog
            title="一键发货"
            :visible="true"
            width="60%"
            :before-close="handleClose">
        <el-form ref="form" :model="form" :rules="rules" label-width="120px"  v-loading="loading">
            <el-form-item label="发货单号:">
                <el-col :span="8">
                    <el-input v-model="form.stock_out_sn"></el-input>
                </el-col>
            </el-form-item>
            <el-form-item label="客户信息:" prop="to_sn">
                <el-col :span="4">
                    <el-input v-model="form.to_sn"></el-input>
                </el-col>
                <el-col class="line" :span="1" style="text-align: center">-</el-col>
                <el-col :span="8">
                    <el-input v-model="form.to_name" readonly></el-input>
                </el-col>
                <el-col :span="4" style="margin-left: 20px">
                    <el-button type="primary" @click="selectCustomer()">选择</el-button>
                </el-col>
            </el-form-item>
            <!-- <el-form-item label="出库仓库:" prop="warehouse_sn">
           <!-- <el-form-item label="出库仓库:" prop="warehouse_sn">
                <el-select v-model="form.warehouse_sn" placeholder="请选择入库仓库">
                    <el-option v-for=" i in stockArray" :key="i.warehouse_sn" :label="i.warehouse_name"
                               :value="i.warehouse_sn"></el-option>
                </el-select>
            </el-form-item> -->
            <!-- </el-form-item>--> 

            <el-form-item label="是否赠品:">
                <el-col :span="8">
                    <el-checkbox-group v-model="form.isgift">
                        <el-checkbox label="" name="type"></el-checkbox>
                    </el-checkbox-group>
                </el-col>
            </el-form-item>
            <el-form-item label="出货时间">
                <el-col :span="8">
                    <el-date-picker type="date" placeholder="选择日期" v-model="form.stock_out_time" style="width: 100%;" ></el-date-picker>
                </el-col>
            </el-form-item>
            <el-form-item label="收货地址:">
                <el-col :span="8">
                    <el-input v-model="form.to_address" ></el-input>
                </el-col>
            </el-form-item>
           <!-- <el-form-item label="发货单位:">
                <el-select v-model="form.instock" placeholder="请选择入库仓库">
                    <el-option label="区域一" value="shanghai"></el-option>
                    <el-option label="区域二" value="beijing"></el-option>
                </el-select>
            </el-form-item>-->
            <el-form-item label="备注:">
                <el-col :span="8">
                    <el-input type="textarea" v-model="form.remarks"></el-input>
                </el-col>
            </el-form-item>
            <el-form-item>
                <el-col :span="8">
                    <el-button type="primary" @click="deliver('form')">一键出货</el-button>
                </el-col>
            </el-form-item>

        </el-form>
        <selectCustomer
        v-if="selectCustomerDialog"
        v-on:handleClose = 'selectCustomerDialog = false'
        @pushData="getInfo">
        </selectCustomer>
    </el-dialog>
</template>

<script>
    import selectCustomer from '../../common/selectRole';
    import { Message } from 'element-ui';
    export default {
        name: "deliverDialog",
        data(){
          return {
              loading:false,
              selectCustomerDialog:false,
              form: {
                  stock_out_sn:'',
                  warehouse_sn:'',
                  to_type:'',
                  to_sn:'',
                  to_name:'',
                  to_address:'',
                  stock_out_time:'',
                  isgift:'',
                  remarks:''
              },
              stockArray:[],
              rules: {
                  stock_in_sn: [
                      {required: true, message: '入库单号不能为空！',}
                  ],
                  to_sn: [
                      {required: true, message: '产品信息不能为空！',}
                  ],
                  to_name:[
                      {required: true, message: '产品信息不能为空！',}
                  ]
              },

          }
        },
        props:{
            delData:{
                type:Object,
                default:function(){
                    return;
                }
            }
        },
        methods:{
            //获取仓库列表(扫二维码)
            getStock() {
                this.$get('logistics', '/warehouses.all', {
                    lang: ''
                }).then(res => {
                    this.stockArray = res.data;
                }).catch(function (error) {
                    console.log(error);
                });
            },
            /*生成随机的单号*/
            randomCode() {
                var randomNum = Math.floor(Math.random() * 9999);
                var myDate = new Date();
                var tY = myDate.getFullYear();
                var tM = myDate.getMonth() + 1;
                if (tM >= 1 && tM <= 9) {
                    tM = "0" + tM;
                }
                var tD = myDate.getDate();
                if (tD >= 1 && tD <= 9) {
                    tD = "0" + tD;
                }
                var hour = myDate.getHours(); // 时
                var minutes = myDate.getMinutes(); // 分
                var seconds = myDate.getSeconds() //秒
                if (hour >= 0 && hour <= 9) {
                    hour = "0" + hour;
                }
                if (minutes >= 0 && minutes <= 9) {
                    minutes = "0" + minutes;
                }
                if (seconds >= 0 && seconds <= 9) {
                    seconds = "0" + seconds;
                }
                this.form.stock_out_sn = 'CH' + tY + tM + tD + hour +minutes + seconds + randomNum;
            },
            //选择客户
            selectCustomer(){
                this.selectCustomerDialog = true;

            },
            getInfo(val){
                console.log(val);
                if(val.dealer_sn){
                    this.form.to_address = val.dealer_address;
                    this.form.to_sn = val.dealer_sn;
                    this.form.to_name = val.dealer_name;
                    this.form.to_type = 2;
                }else if(val.shop_sn){
                    this.form.to_address = val.address;
                    this.form.to_sn = val.shop_sn;
                    this.form.to_name = val.shop_name;
                    this.form.to_type = 3;

                }

            },
            //一键出货
            deliver(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let url = '/inwarehouses/' + this.delData.stock_in_sn + '/outwarehouses',isgift = 2;
                        if(this.form.isgift){
                            isgift = 1;
                        }else{
                            isgift = 2;
                        }
                        this.loading = true;
                        this.$post('logistics',url, {
                            lang:'',
                            inwarehouse:this.delData.stock_in_sn,
                            stock_out_sn:this.form.stock_out_sn,
                            warehouse_sn:this.delData.warehouse_sn,
                            to_type:this.form.to_type,
                            to_sn:this.form.to_sn,
                            to_name:this.form.to_name,
                            to_address:this.form.to_address,
                            stock_out_time:this.form.stock_out_time,
                            isgift:isgift,
                            remarks:this.form.remarks
                        }).then(res => {
                            console.log(res);
                            this.loading = false;
                            if (res.message == '操作成功') {
                                this.$message({
                                    message: '一键出货成功',
                                    type: 'success'
                                });
                                this.$router.push({
                                    name: 'instockManage'
                                });
                            }
                        }).catch(error =>{
                            this.loading = false;
                            this.$message({
                                type: 'error',
                                message: error.message
                            });

                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });


            },
            handleClose(){
                this.$emit('handleClose');
            }
        },
        created(){
            this.getStock();
            this.randomCode();

        },
        components:{
            selectCustomer
        }
    }
</script>

<style scoped>

</style>